/* This copyToClipboard Utility is necessary for Copy functions for RoundID
 and to be compatible with mobile devices */

export const copyToClipboard = (text) => {
  return new Promise((resolve, reject) => {
    const el = document.createElement('textarea');
    el.value = text;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    
    document.body.appendChild(el);
    
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
      const range = document.createRange();
      range.selectNodeContents(el);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      el.setSelectionRange(0, 999999);
    } else {
      el.select();
    }
    
    let success = false;
    try {
      success = document.execCommand('copy');
    } catch (err) {
      console.error('execCommand failed:', err);
    }
    
    // Cleanup
    document.body.removeChild(el);
    
    if (success) {
      resolve();
    } else {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text)
          .then(resolve)
          .catch(reject);
      } else {
        reject(new Error('Clipboard copy failed'));
      }
    }
  });
};
